<template>
  <v-card>
    <v-alert
      :color="`${color} lighten-4`"
      border="left"
      colored-border
    >
      <v-card-text class="py-0">
        <v-row>
          <v-col cols="8">
            <h3>
              <v-chip
                small
                label
                :color="color"
                text-color="white"
                class="mr-2"
              >
                {{ label }}
              </v-chip>{{ item.title }}
            </h3>
          </v-col>
          <v-col cols="4">
            <v-row>
              <DecimalEditor
                v-model="amount"
                label="Сумма"
                :hide-details="false"
                :error-messages="$v.amount.$error ? errors.ONLY_POSITIVE : []"
                @input="changeAmount"
              />
              <v-btn
                large
                icon
                @click="remove"
              >
                <v-icon>delete_outline</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="item.type === 'product'"
            cols="8"
          >
            <h3>
              <v-chip
                small
                label
                text-color="black"
                class="mr-2"
              >
                {{ "Артикул" }}
              </v-chip>{{ item.article }}
            </h3>
          </v-col>
          <v-col
            v-if="item.type === 'service'"
            cols="4"
          >
            <DecimalEditor
              v-if="item.type === 'service'"
              :value="item.quantity"
              label="Кількість"
              hide-details
              readonly
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-alert>
  </v-card>
</template>

<script>
import DecimalEditor from "@/components/DecimalEditor.vue";
import { ERRORS } from "@/helpers";
import { minValue } from "vuelidate/lib/validators";
export default {
  components: {
    DecimalEditor,
  },
  props: ["item"],
  data() {
    return {
      amount: this.item.amount,
    };
  },
  validations: {
    amount: {
      minValue: minValue(0),
    },
  },
  computed: {
    color() {
      switch (this.item.type) {
        case "service":
          return "orange";
        case "product":
          return "blue";
        case "package":
          return "green";
      }
    },
    label() {
      switch (this.item.type) {
        case "service":
          return "Сервіс";
        case "product":
          return "Продукт";
        case "package":
          return "Пакет";
      }
    },
    errors() {
      return {
        ONLY_POSITIVE: [ERRORS.ONLY_POSITIVE],
      };
    },
  },
  methods: {
    remove() {
      this.$emit("remove", this.item);
    },
    changeAmount() {
      this.$v.amount.$touch();
      if (!this.$v.amount.$invalid) {
        this.$emit("change");
      }
    },
  },
};
</script>
